import { Pipe, PipeTransform } from '@angular/core';

/**
 *
 */
@Pipe({ name: 'dots' })
export class DotsPipe implements PipeTransform {
  /**
   *
   * @param value
   * @returns {string}
   */
  transform(value: any, id: any): any {
    const resultString = value.map((data, index) => data.userId !== id ? data.userName : data.userId).filter(function (e) { return e !== id });
    return (resultString.toString().length > 25) ? `${resultString.toString().substr(0, 25)}...` : resultString.toString();
  }
}
